import { apiClient } from "../client";

export interface CheckoutCartItem {
  product_id: number;
  quantity: number;
  /** Selected add-on option ids — the server charges total_price + their prices. */
  variation_id?: number[];
  [key: string]: unknown;
}

export interface PlaceOrderPayload {
  user_id: number | string;
  address_id: number | string;
  /** e.g. "razorpay" | "cod" */
  payment_method: string;
  coupon_code?: string;
  order_notes?: string;
  cart_items: CheckoutCartItem[];
  [key: string]: unknown;
}

/** Razorpay bootstrap data returned by place-order. */
export interface PlaceOrderResponse {
  status?: boolean;
  message?: string;
  /** Internal order id — echoed back on verify. */
  order_id?: number | string;
  /** Human-readable "ORD…" order number — assigned when the order row is
   * created (its timestamp suffix matches `created_at`, not the payment
   * time), so it's already final here. This — not `order_id` — is what
   * `/orders/:orderNumber` and trackOrder() key off of. */
  order_number?: string;
  /** Razorpay order id for the checkout popup. */
  razorpay_order_id?: string;
  /** Amount in paise, as Razorpay expects. */
  amount?: number | string;
  currency?: string;
  /** Razorpay public key id. */
  key?: string;
  user?: {
    first_name?: string;
    last_name?: string;
    email?: string;
    mobile_no?: string;
    [key: string]: unknown;
  };
  coupon_discount?: number | string;
  price_gst?: number | string;
  discounted_price?: number | string;
  [key: string]: unknown;
}

export interface VerifyPaymentPayload {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
  order_id: number | string;
  [key: string]: unknown;
}

export interface VerifyPaymentResponse {
  status: boolean;
  message?: string;
  [key: string]: unknown;
}

export const checkout = {
  /** Create the order upstream and get the Razorpay bootstrap data. */
  placeOrder: (payload: PlaceOrderPayload) =>
    apiClient.post<PlaceOrderResponse>("/checkout/place-order", payload),

  /** Confirm a completed Razorpay payment (signature verification). */
  verifyPayment: (payload: VerifyPaymentPayload) =>
    apiClient.post<VerifyPaymentResponse>("/checkout/payment/verify", payload),
};
